
export const typeTransform = {
  "legalAssistance": "Legal Assistance",
  "cvcp": "$1,000's of Dollars You May Be Eligible for",
  "lgbtq+": 'Resources for LGBTQ+ Survivors of Violence',
  "blind": 'Resources for Blind Survivors',
  "childAvocate": "Child Advocate",
  "leaAndCourtAdvocateInfo": "Legal and Court Advocate Info",
  "dcyf": "DCYF: Resource for Children Witnessing/Experiencing Abuse",
  "deaf": "Resources for Deaf Survivors",
  "relay": 'Resources for Deaf/Blind/Disabled',
  "domesticViolence": "Domestic Violence Shelters in Your State",
  "clinical": 'Free Clinical Services',
  "freePsychologicalConselling": 'Free Psychological Counselling',
  'hivAids': 'Free Testing and Medicine if You Suspect You Could Have HIV/AIDS',
  "homelessness": 'Resources for Survivors Experiencing Houselessness',
  "incarcerated": 'Resources for Incarcerated Survivors',
  "noContactOrder": 'Obtaining a No Contact Order',
  "disability": 'People with Disabilites',
  "sa": "Sexual Assault Organizations",
  "restrainingOrder": "Obtaining a Temporary Restraining Order",
  "trafickingSurvivor": "Resources for Human Trafficking Survivors",
  "undocumentedImmigrants": "Resources/Lawyers for Undocumented Immigrant Survivors",
  "vine": "VINE: Get Notified When Your Abuser is Released From Prison"
}

export const categoryTransform = {
  "$1,000's of Dollars You May Be Eligible for": "Financial Resources",

  "Sexual Assault Organizations": "Organizations for Survivors",
  "Domestic Violence Shelters in Your State": "Organizations for Survivors",
  "DCYF: Resource for Children Witnessing/Experiencing Abuse": "Organizations for Survivors",
  "Resources for Human Trafficking Survivors": "Organizations for Survivors",

  "Free Psychological Counselling": "Medical Resources",
  "Free Clinical Services": "Medical Resources",
  "Free Testing and Medicine if You Suspect You Could Have HIV/AIDS": "Medical Resources",

  "Law Enforcement Advocate": "Legal Resources",
  "Legal and Court Advocate Info": "Legal Resources",
  "Legal Assistance": "Legal Resources",
  "VINE: Get Notified When Your Abuser is Released From Prison": "Legal Resources",
  "Help Filing a Police Report": "Legal Resources",
  "Obtaining a Temporary Restraining Order": "Legal Resources",
  "Obtaining a No Contact Order": "Legal Resources",
  "Resources/Lawyers for Undocumented Immigrant Survivors": "Legal Resources",

  "Resources for Survivors Experiencing Houselessness": "Identity/Disability/Situational Resources",
  "Resources for LGBTQ+ Survivors of Violence": "Identity/Disability/Situational Resources",
  "Resources for Blind Survivors": "Identity/Disability/Situational Resources",
  "Resources for Deaf Survivors": "Identity/Disability/Situational Resources",
  "Resources for Deaf/Blind/Disabled": "Identity/Disability/Situational Resources",
  "Resources for Incarcerated Survivors": "Identity/Disability/Situational Resources",
}